import { type } from "arktype";

import { autoFieldColumn } from "@/api/document/columns";
import { DocumentFields } from "@/api/document/fields";

const field = type({
	label: type("string.trim").to("string > 0"),
	column: autoFieldColumn,
	format: "string.trim",
})
	.pipe((field) => ({
		label: field.label,
		column: field.column,
		format: field.format.length === 0 ? undefined : field.format,
	}))
	.narrow((field, ctx) => {
		if (
			field.format === undefined ||
			DocumentFields.typeOf(field.column) !== "string" ||
			field.format.includes("#")
		) {
			return true;
		}

		return ctx.mustBe("a mask with # slots for text columns");
	});

const rename = type({ label: type("string.trim").to("string > 0") });

export const DocumentFieldFormSchemas = { field, rename };
